import React from "react";
import "./styles/Field.css";

/**
 * Field - Label, control, hint and error for one form input.
 *
 * @param {Object} props
 * @param {string} props.label - Field label
 * @param {string} props.hint - Guidance shown under the control
 * @param {string} props.error - Error message; also puts the control in its error state
 * @param {boolean} props.required - Mark the field as required
 * @param {boolean} props.optional - Mark the field as optional
 * @param {string} props.htmlFor - id of the control the label points at
 * @param {React.ReactNode} props.children - The control itself
 */
const Field = ({
  label,
  hint,
  error,
  required = false,
  optional = false,
  htmlFor,
  children,
}) => {
  return (
    <div className={`dsField ${error ? "hasError" : ""}`}>
      {label && (
        <label className="dsFieldLabel" htmlFor={htmlFor}>
          {label}
          {required && (
            <span className="dsFieldRequired" aria-hidden="true">
              *
            </span>
          )}
          {optional && !required && (
            <span className="dsFieldOptional">Optional</span>
          )}
        </label>
      )}
      {children}
      {error ? (
        <span className="dsFieldError" role="alert">
          {error}
        </span>
      ) : (
        hint && <span className="dsFieldHint">{hint}</span>
      )}
    </div>
  );
};

export default Field;
